import React, { useEffect, useRef, useState } from "react";

import { useStateContext } from "@/context/context-provider";

const Sounds = () => {
    const { pickedup, solved, soundSettings } = useStateContext();
    const solvedSound = useRef();
    const pickedupSound = useRef();
    const backgroundSound = useRef();
    const [firstRunSolved, setFirstRunSolved] = useState(true);
    const [firstRunPickUp, setFirstRunPickUp] = useState(true);

    useEffect(() => {
        if (!soundSettings.muted && !firstRunSolved) {
            solvedSound.current.volume = soundSettings.volume * 0.1;
            solvedSound.current.playbackRate = 1.5;

            solvedSound.current.play().catch((error) => {
                console.warn("Konnte solved-Sound nicht abspielen:", error);
            });
        }
        setFirstRunSolved(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solved]);

    useEffect(() => {
        if (!soundSettings.muted && !firstRunPickUp) {
            pickedupSound.current.volume = soundSettings.volume * 0.02;
            pickedupSound.current.playbackRate = 1.5;
            pickedupSound.current.play().catch((error) => {
                console.warn("Konnte solved-Sound nicht abspielen:", error);
            });
        }
        setFirstRunPickUp(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pickedup]);

    useEffect(() => {
        if (!soundSettings.mutedBackground) {
            backgroundSound.current.volume = soundSettings.volumeBackground * 0.01;
            backgroundSound.current.play().catch((error) => {
                console.warn("Konnte Hintergrundsound nicht abspielen:", error);
            });
        }
    }, [soundSettings]);

    return (
        <>
            <audio ref={solvedSound} src="/general/sounds/solve.mp3" preload="auto" muted={soundSettings.muted} />
            <audio ref={pickedupSound} src="/general/sounds/pickup.mp3" preload="auto" muted={soundSettings.muted} />

            <audio
                ref={backgroundSound}
                src="/general/sounds/background.mp3"
                preload="auto"
                loop
                muted={soundSettings.mutedBackground}
                onCanPlay={() => {
                    if (backgroundSound.current) {
                        backgroundSound.current.volumeBackground = 0.01;
                        backgroundSound.current.play().catch((error) => {
                            console.warn("Konnte Hintergrundsound nicht abspielen:", error);
                        });
                    }
                }}
            />
        </>
    );
};

export default Sounds;
